import React from "react";
import PropTypes from "prop-types";

import Scheduler from "components/Scheduler";

import ReminderTile from "scenes/Hubly/components/Workspace/components/ReminderTile";

import { FormModal, ReminderOptions } from "./components";

export function Reminder({ r, processing }) {
  const [isSchedulerOpen, openScheduler] = React.useState(false);
  const [reminderWithTask, setReminderWithTask] = React.useState(null);

  return (
    <React.Fragment>
      <ReminderOptions
        onReschedule={() => {
          openScheduler(true);
        }}
        onDismiss={r.dismiss}
        onCompleteTask={() => {
          return r.task?.formInstanceId && !r.task?.formInstance?.isFilled
            ? setReminderWithTask(r)
            : r.task?.complete();
        }}
        onOpenClientCard={r.viewClientCard}
      >
        <ReminderTile reminder={r} spinning={processing} />
      </ReminderOptions>

      {isSchedulerOpen && (
        <Scheduler.Dialog
          title={r.title}
          value={r.time}
          onSave={(newDate) => {
            r.reschedule(newDate);
            openScheduler(false);
          }}
          onCancel={() => {
            openScheduler(false);
          }}
        />
      )}
      {reminderWithTask && (
        <FormModal
          formId={reminderWithTask.task.formInstanceId}
          onClose={() => {
            setReminderWithTask(null);
          }}
          onDone={() => {
            reminderWithTask.task.complete().finally(() => {
              setReminderWithTask(null);
            });
          }}
        />
      )}
    </React.Fragment>
  );
}

Reminder.propTypes = {
  r: PropTypes.shape({
    title: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    dismiss: PropTypes.func.isRequired,
    viewClientCard: PropTypes.func.isRequired,
    reschedule: PropTypes.func.isRequired,
    task: PropTypes.object,
  }).isRequired,
  processing: PropTypes.bool,
};

Reminder.defaultProps = {
  processing: false,
};

export default Reminder;
